export class AccessConditionalExpression {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "group",
            "baseName": "group",
            "type": "RoleAccessGroupCondition",
            "format": ""
        },
        {
            "name": "resourceType",
            "baseName": "resourceType",
            "type": "ResourceTypeCondition",
            "format": ""
        },
        {
            "name": "dataClasses",
            "baseName": "dataClasses",
            "type": "DataClassesCondition",
            "format": ""
        },
        {
            "name": "environment",
            "baseName": "environment",
            "type": "EnvironmentCondition",
            "format": ""
        },
        {
            "name": "apps",
            "baseName": "apps",
            "type": "AppsCondition",
            "format": ""
        },
        {
            "name": "cloudProvider",
            "baseName": "cloudProvider",
            "type": "CloudProviderCondition",
            "format": ""
        },
        {
            "name": "accountId",
            "baseName": "accountId",
            "type": "AccountIdCondition",
            "format": ""
        },
        {
            "name": "sourceRegion",
            "baseName": "sourceRegion",
            "type": "RegionCondition",
            "format": ""
        },
        {
            "name": "vpc",
            "baseName": "vpc",
            "type": "VpcCondition",
            "format": ""
        },
        {
            "name": "subnets",
            "baseName": "subnets",
            "type": "SubnetsCondition",
            "format": ""
        },
        {
            "name": "resourceGroupName",
            "baseName": "resourceGroupName",
            "type": "ResourceGroupNameCondition",
            "format": ""
        },
        {
            "name": "resourceName",
            "baseName": "resourceName",
            "type": "ResourceNameCondition",
            "format": ""
        },
        {
            "name": "resourceId",
            "baseName": "resourceId",
            "type": "ResourceIdCondition",
            "format": ""
        },
        {
            "name": "tagKeys",
            "baseName": "tagKeys",
            "type": "TagKeysCondition",
            "format": ""
        },
        {
            "name": "tagKeyValues",
            "baseName": "tagKeyValues",
            "type": "TagKeyValuesCondition",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return AccessConditionalExpression.attributeTypeMap;
    }
    constructor() {
    }
}
